var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8585",
    "data-name": "Rectangle 8585",
    width: 24,
    height: 24,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9536",
    "data-name": "Group 9536",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14580",
    "data-name": "Path 14580",
    d: "M1126.05,304.75a13.919,13.919,0,0,0,14.01-14.008c0-.211-.01-.427-.02-.638a9.9,9.9,0,0,0,2.46-2.549,9.718,9.718,0,0,1-2.83.774,4.957,4.957,0,0,0,2.17-2.723,9.877,9.877,0,0,1-3.13,1.2,4.935,4.935,0,0,0-8.08,1.34,5.011,5.011,0,0,0-.31,3.149,14,14,0,0,1-10.15-5.14,4.943,4.943,0,0,0,1.53,6.57,4.883,4.883,0,0,1-2.23-.614v.061a4.915,4.915,0,0,0,3.95,4.828,4.931,4.931,0,0,1-2.23.084,4.958,4.958,0,0,0,4.6,3.422,9.852,9.852,0,0,1-7.29,2.037A13.951,13.951,0,0,0,1126.05,304.75Z",
    transform: "translate(-1118.5 -283)",
    fill: "#858689"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwi);
export default __webpack_public_path__ + "static/media/twi.74e1de528e4dd5495add28edd625795b.svg";
export { ForwardRef as ReactComponent };